import { PilotId } from '~/eds/src/types/PilotId';
import { pilotV3 } from '~/services/serviceInstances';

type Request = {
  id: PilotId;
};

export const deleteSearchV3SavedSearch = ({ id }: Request): Promise<void> => {
  return pilotV3.remove(`/saved-search/${id}/`);
};
